<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;" class="loadingContainer">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 60px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="startLoading" class="breadCrumb">
        Loading
      </v-btn>
      <v-btn @click="selectLoaderType(currentType)" v-if="currentType" class="breadCrumb">
        {{ currentType === 'SHIPMENT' ? 'Shipments' : 'Internal transport' }}
      </v-btn>
      <v-btn @click="selectPickupAddress(currentPickupAddress)" v-if="currentPickupAddress" class="breadCrumb">
        {{ currentPickupAddress.text }}
      </v-btn>
      <v-btn @click="selectShipment(currentShipment)" v-if="currentShipment" class="breadCrumb">
        {{ currentShipment.number }}
      </v-btn>
      <v-btn @click="startEnterPalletNumber" class="btnPrintReport" style="float: right;" v-if="showInternalTransport">Enter pallet number</v-btn>
      <v-btn @click="printDeliveryNote" class="btnPrintReport" style="float: right;" v-if="currentShipment && completed">Print</v-btn>
      <v-btn @click="deleteInternalTransportShipment()" v-if="canCancelInternalTransport" class="btnFinalizeShipment">Cancel internal transport</v-btn>
      <v-btn @click="tryCompleteShipment()" v-if="currentShipment" class="btnFinalizeShipment" :disabled="completeShipmentDisabled">Loading complete</v-btn>
      <div style="display: inline; float: right;" v-if="currentPickupAddress && currentType === 'SHIPMENT' && !currentShipment">
        <v-btn @click="toggleFilterCompleted(false)" class="btnToggleFilter" :disabled="!completed">Waiting</v-btn>
        <v-btn @click="toggleFilterCompleted(true)" class="btnToggleFilter" :disabled="completed">Completed</v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-flex xs12 v-if="showSelectLoaderType">
      <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
        <v-btn @click="selectLoaderType('SHIPMENT')" :style="'width: 100%; height: 20vh !important; font-size: 36pt !important; margin-bottom: 2vh !important;'" v-if="handleShipments">Shipments</v-btn>
        <v-btn @click="selectLoaderType('INTERN_TRANSPORT_SHIPMENT')" :style="'width: 100%; height: 20vh !important; font-size: 36pt !important; margin-bottom: 2vh !important;'">Create internal transport</v-btn>
        <v-btn @click="selectLoaderType('INTERN_TRANSPORT')" :style="'width: 100%; height: 20vh !important; font-size: 36pt !important;'" v-if="handleInternalTransport">Internal transport</v-btn>
      </v-flex>
    </v-flex>
    <v-container fluid pa-0 v-show="showPickupAddressList">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-flex xs12 v-for="(pickupAddress, i) in pickupAddresses" :key="i" :style="'height: ' + Math.min(20, Math.max(6, 65 / pickupAddresses.length)) + 'vh; min-height: 5vh !important; margin-bottom: ' + (Math.max(0.5, 8 / pickupAddresses.length)) + 'vh !important;'" class="pickupAddressButton">
            <v-btn @click="selectPickupAddress(pickupAddress)" :style="'width: 100%; height: ' + Math.min(20, Math.max(6, 65 / pickupAddresses.length)) + 'vh !important; min-height: 5vh !important; max-height: 30vh !important; font-size: ' + Math.min(Math.max(50 - (5 * pickupAddresses.length), 14), 25) + 'pt !important;'"><v-icon :style="pickupAddressIconStyle(pickupAddress)">error</v-icon>{{ pickupAddress.text }}</v-btn>
          </v-flex>
          <div style="padding-top: 20vh; width: 100%; text-align: center; font-size: 20px;" v-show="pickupAddresses.length === 0">No loading addresses found</div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid pa-0 v-show="showInternalTransport && !showInternalTransportManualNumber">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;" class="internalTransportPanel">
          <v-data-table :headers="palletHeaders" :items="pallets" hide-actions v-if="pallets.length > 0">
            <template v-slot:items="props">
              <tr @click="selectPalletForInternalTransport(props.item)" class="selectable">
                <td class="text-xs-left">{{ props.item.palletNumber }}</td>
                <td class="text-xs-left">{{ props.item.shipmentNumber }}</td>
                <td class="text-xs-left">{{ props.item.pickupDate }}</td>
                <td class="text-xs-left"><v-icon v-if="props.item.state === 'IN_TRANSPORT'">done</v-icon></td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="showInternalTransportPalletDialog" width="70vh" attach=".internalTransportPanel" class="palletDialog internalTransportPalletDialog" v-if="currentPallet" persistent>
            <table style="width: 100%;">
              <tr>
                <td colspan="2" style="padding: 20px 50px; font-size: 5vh; text-align: center;">Pallet #{{ currentPallet.palletNumber }}</td>
              </tr>
              <tr>
                <td style="width: 50%; padding-right: 10px; padding-bottom: 10px;">
                  <div class="loadInternalBtn" @click="loadInternalTransport(currentPallet)" style="width: 80%; float: right;" v-if="currentPallet.state !== 'IN_TRANSPORT'">Load</div>
                  <div class="loadInternalBtn" @click="unloadInternalTransport()" style="width: 80%; float: right;" v-if="currentPallet.state === 'IN_TRANSPORT'">Unload</div>
                </td>
                <td style="width: 50%; padding-left: 10px; padding-bottom: 10px;">
                  <div class="loadInternalBtn" @click="cancelInternalTransport()" style="width: 80%; float: left;">Cancel</div>
                </td>
              </tr>
            </table>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid pa-2 v-if="showInternalTransportManualNumber" style="position: absolute; top: 50%; transform: translateY(-50%)">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex xs12 md5 lg4 pa-3>
          <table class="numberPad" style="width: 100%;">
            <tr>
              <td colspan="3"><div class="numberPadValue">{{ currentPalletNumber }}</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
              <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
              <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
              <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
              <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
              <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
              <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
            </tr>
            <tr>
              <td><div class="numberBtn" @click="clear()">Clr</div></td>
              <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
              <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
            </tr>
            <tr>
              <td colspan="3"><div :class="'loadManualBtn' + (!loadManualButtonEnabled ? ' disabled' : '')" @click="tryLoadInternalTransport()">Load</div></td>
            </tr>
          </table>
        </v-flex>
        <v-flex xs12 md7 lg8 pa-3>
          <PanelColumn title="Loading history" margin-bottom="0"/>
          <v-data-table :headers="historyHeaders" :items="historyItems" hide-actions class="historyTable" v-if="historyItems.length > 0">
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ formatDatetime(props.item.timestamp) }}</td>
                <td class="text-xs-left">{{ props.item.pallet.number }}</td>
                <td class="text-xs-left"><div v-html="categories(props.item.pallet)"></div></td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid pa-0 v-show="showShipmentListReadyForPickup">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <v-data-table :headers="shipmentHeaders" :items="filteredShipments" :search="shipmentSearch" hide-actions v-if="filteredShipments.length > 0">
            <template v-slot:items="props">
              <tr @click="selectShipment(props.item)" class="selectable">
                <td class="text-xs-left">{{ props.item.number }}</td>
                <td class="text-xs-left" style="white-space: nowrap;">{{ stateLabel(props.item.state) }}</td>
                <td class="text-xs-left">{{ props.item.pickupDate }}</td>
                <td class="text-xs-left">{{ props.item.deliveryDate }}</td>
                <td class="text-xs-left">{{ props.item.carrierName }}</td>
                <td class="text-xs-left">{{ props.item.licensePlate }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-show="showShipment" class="shipmentContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <Panel :title="'Shipment #' + currentShipment.number" v-if="showShipment" class="shipmentPanel">
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              <v-label>Carrier</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.carrierName }}
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport"/>
            <v-flex xs12 sm4 v-if="!currentShipment.internalTransport">
              <v-label>Loading date</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.pickupDate }}
            </v-flex>
            <v-flex xs12 sm2>
              <v-label>License plate(s)</v-label>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field v-model="currentShipment.licensePlate" style="margin-right: 20px;"/>
            </v-flex>
            <v-flex xs12 sm6 v-if="showShipmentComment">
              <div style="white-space: pre-wrap;">{{ currentShipment.comment }}</div>
            </v-flex>
            <v-flex xs12 style="height: 10px;"/>
            <v-flex xs12 v-if="palletOrders && palletOrders.length > 0" class="truckContainer">
              <v-btn @click="driveTruck" v-if="false">Drive truck</v-btn>
              <table style="width: 100%;">
                <tr style="height: 400px;">
                  <td>
                    <transition name="truckLeave">
                      <table class="palletPosition truck" v-if="showTruck">
                        <tr>
                          <td rowspan="4" class="front"></td>
                          <td colspan="5" style="height: 22px; background: transparent;"></td>
                        </tr>
                        <tr class="rightSide">
                          <LoaderPallet number="1" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected" style="border-top-left-radius: 8px;"/>
                          <LoaderPallet number="3" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="5" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="7" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="9" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected" style="border-top-right-radius: 8px;"/>
                        </tr>
                        <tr class="leftSide">
                          <LoaderPallet number="2" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected" style="border-bottom-left-radius: 8px;"/>
                          <LoaderPallet number="4" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="6" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="8" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected"/>
                          <LoaderPallet number="10" :palletPositions="palletPositions" :currentShipment="currentShipment" :currentPallet="currentPallet" :currentPosition="Number(currentPosition)" :pickup-address="currentPickupAddress" :pallet-orders="palletOrders" @change="palletSelected" style="border-bottom-right-radius: 8px;"/>
                        </tr>
                        <tr>
                          <td colspan="5" style="height: 22px; background: transparent;"></td>
                        </tr>
                      </table>
                    </transition>
                  </td>
                  <td :style="'padding: ' + (hasPalletsToLoad ? '25px 0 25px 10px' : '0') + '; background: transparent; vertical-align: top; min-width: ' + (hasPalletsToLoad ? 100 : 1) + 'px !important; max-width: 20% !important;'">
                    <div v-if="hasPalletsToLoad" v-for="palletsToLoad in palletsToLoad" :key="palletsToLoad.deliveryZone" :class="'deliveryGroup deliveryZone_' + palletsToLoad.deliveryZone" :style="showPalletsToLoad ? '' : 'opacity: 0;'">
                      <table class="palletsToLoad">
                        <tr v-for="palletToLoad in palletsToLoad.palletsToLoad" :key="palletToLoad.key">
                          <td style="font-size: 12px; white-space: nowrap; padding-left: 5px;">
                            {{ palletToLoad.numberOfPallets }} x
                          </td>
                          <td style="padding-left: 0; font-size: 10px;">
                            <PalletItems v-if="palletToLoad.items" :items="palletToLoad.items" no-amount="true" no-planned-amount="true"/>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>
              <v-dialog v-model="showPalletDialog" width="70vh" class="palletDialog" attach=".shipmentPanel" v-if="currentPallet" persistent>
                <div v-if="errorMessage" style="padding: 12px 25px; color: red; text-align: center; font-weight: bold;">
                  {{ errorMessage }}
                </div>
                <table class="numberPad" style="width: 100%;">
                  <tr>
                    <td colspan="3"><div class="numberPadValue">{{ currentPalletNumber }}</div></td>
                    <td rowspan="4" class="wide"><div :class="'loadPalletBtn' + (!loadPalletButtonEnabled ? ' disabled' : '')" @click="tryLoadPallet()"><v-icon>done</v-icon></div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(1)">1</div></td>
                    <td><div class="numberBtn" @click="numberClick(2)">2</div></td>
                    <td><div class="numberBtn" @click="numberClick(3)">3</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(4)">4</div></td>
                    <td><div class="numberBtn" @click="numberClick(5)">5</div></td>
                    <td><div class="numberBtn" @click="numberClick(6)">6</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="numberClick(7)">7</div></td>
                    <td><div class="numberBtn" @click="numberClick(8)">8</div></td>
                    <td><div class="numberBtn" @click="numberClick(9)">9</div></td>
                  </tr>
                  <tr>
                    <td><div class="numberBtn" @click="clear()">Clr</div></td>
                    <td><div class="numberBtn" @click="numberClick(0)">0</div></td>
                    <td><div class="numberBtn" @click="backspace()"><v-icon style="color: #DDDDDD; font-size: 5vh;">keyboard_backspace</v-icon></div></td>
                    <td class="wide"><div class="cancelBtn" @click="cancel()">Cancel</div></td>
                  </tr>
                </table>
              </v-dialog>
              <v-dialog v-model="showPalletUnloadDialog" width="70vh" attach=".shipmentPanel" class="palletDialog" v-if="currentPallet" persistent>
                <table style="width: 100%;">
                  <tr>
                    <td colspan="2" style="padding: 20px 50px; font-size: 5vh; text-align: center;">Pallet #{{ currentPallet.palletNumber }}</td>
                  </tr>
                  <tr>
                    <td style="width: 50%; padding-right: 10px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="unloadPallet()" style="width: 80%; float: right;">Unload</div>
                    </td>
                    <td style="width: 50%; padding-left: 10px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="cancelUnloadPallet()" style="width: 80%; float: left;">Cancel</div>
                    </td>
                  </tr>
                </table>
              </v-dialog>
              <v-dialog v-model="showCompleteShipmentWarningDialog" width="60vw" attach=".shipmentPanel" class="palletDialog" v-if="currentShipment" persistent>
                <table style="width: 100%;">
                  <tr>
                    <td colspan="2" style="padding-top: 10px;">&nbsp;</td>
                  </tr>
                  <tr v-if="licensePlateMissing">
                    <td colspan="2" style="padding: 1px 50px; font-size: 4vh; text-align: center;">License plate(s) have not been filled in</td>
                  </tr>
                  <tr v-if="incomplete">
                    <td colspan="2" style="padding: 1px 50px; font-size: 4vh; text-align: center;">Pallets have different content than planned</td>
                  </tr>
                  <tr>
                    <td colspan="2" style="padding-top: 10px;">&nbsp;</td>
                  </tr>
                  <tr>
                    <td style="width: 50%; padding-right: 20px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="completeShipment()" style="width: 80%; float: right;">Continue</div>
                    </td>
                    <td style="width: 50%; padding-left: 10px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="cancelCompleteShipment()" style="width: 80%; float: left;">Cancel</div>
                    </td>
                  </tr>
                </table>
              </v-dialog>
              <v-dialog v-model="showContentMismatchDialog" width="60vw" attach=".shipmentPanel" class="palletDialog" v-if="currentShipment" persistent>
                <table style="width: 100%;">
                  <tr>
                    <td colspan="2" style="padding: 20px 50px; font-size: 4vh; text-align: center;">The pallet content is not planned for this position</td>
                  </tr>
                  <tr>
                    <td style="width: 50%; padding-right: 10px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="loadPallet(chosenPallet)" style="width: 80%; float: right;">Continue anyway</div>
                    </td>
                    <td style="width: 50%; padding-left: 10px; padding-bottom: 10px;">
                      <div class="loadInternalBtn" @click="showContentMismatchDialog = false" style="width: 80%; float: left;">Cancel</div>
                    </td>
                  </tr>
                </table>
              </v-dialog>
            </v-flex>
            <v-flex xs12 text-xs-right v-if="false">
              <v-btn @click="finalizeShipment()" class="breadCrumb">Loading completed</v-btn>
            </v-flex>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showChoosePalletDialog" attach=".loadingContainer" width="unset" persistent hide-overlay>
      <v-card pa-5>
        <v-card-title class="headline">Choose pallet to load</v-card-title>
        <v-card-text style="padding-bottom: 0;">
          <div style="padding-bottom: 0;">There is more than one pallet with this number, please choose one.</div>
          <div v-if="errorMessage" style="padding: 8px; border: 1px solid red; border-radius: 3px; color: red; text-align: center; font-weight: bold;">
            {{ errorMessage }}
          </div>
          <div style="height: 10px;"></div>
          <v-radio-group v-model="chosenPallet">
            <table class="choosePallet">
              <tr>
                <th></th>
                <th class="text-xs-left" style="width: 100px;">Pallet no.</th>
                <th class="text-xs-left" style="width: 140px;">Ext. pallet no.</th>
                <th class="text-xs-left" style="width: 120px;">State</th>
                <th class="text-xs-left">Category</th>
                <th class="text-xs-right" style="width: 110px;">Amount</th>
              </tr>
              <tr v-for="pallet in this.palletsByNumber" v-bind:key="pallet.id">
                <td>
                  <v-radio :value="pallet" color="#004d40"></v-radio>
                </td>
                <td class="text-xs-left">{{ pallet.number }}</td>
                <td class="text-xs-left">{{ pallet.externalNumber }}</td>
                <td class="text-xs-left">{{ pallet.stateLabel }}</td>
                <td class="text-xs-left"><div v-html="pallet.categories"></div></td>
                <td class="text-xs-right" style="width: 60px;"><div v-html="pallet.amounts"></div></td>
              </tr>
            </table>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="loadChosenPallet" class="bw-4 choosePalletButton" :disabled="chosenPallet === null" v-if="currentType === 'SHIPMENT'">Load</v-btn>
          <v-btn flat @click="loadChosenPalletInternalTransport" class="bw-4 choosePalletButton" :disabled="chosenPallet === null" v-if="currentType === 'INTERN_TRANSPORT'">Load</v-btn>
          <div style="width: 10px;"></div>
          <v-btn flat @click="cancelChoosePallet" class="bw-4 choosePalletButton">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import LoaderPallet from '../components/LoaderPallet'
import PalletItems from '../components/PalletItems'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import DateUtil from '@/assets/javascript/dateutil'

export default {
  name: 'TodoLoading',
  components: { Panel, LoaderPallet, PalletItems, PanelColumn, ErrorDialog },
  data () {
    return {
      pickupAddresses: [],
      pickupAddressesLoaded: false,
      currentPickupAddress: null,
      currentType: null,
      currentShipment: null,
      shipments: [],
      loadingReceipts: [],
      shipmentsLoaded: false,
      shipmentSearch: '',
      shipmentHeaders: [
        { text: 'No.', value: 'number', sortable: false },
        { text: 'State', value: 'state', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: false },
        { text: 'Delivery date', value: 'deliveryDate', sortable: false },
        { text: 'Carrier', value: 'carrierName', sortable: false },
        { text: 'License plate', value: 'licensePlate', sortable: false }
      ],
      palletsLoaded: false,
      historyItems: [],
      historyHeaders: [
        { text: 'Timestamp', value: 'timestamp', sortable: false },
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Categories', sortable: false }
      ],
      palletHeaders: [
        { text: 'Pallet no.', value: 'number', sortable: true },
        { text: 'Shipment no.', value: 'shipmentNumber', sortable: true },
        { text: 'Loading date', value: 'pickupDate', sortable: true },
        { text: 'Loaded', sortable: false }
      ],
      palletOrders: [],
      pallets: [],
      palletPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      currentPalletNumber: null,
      currentPallet: null,
      currentPosition: null,
      lastPosition: null,
      showPalletDialog: false,
      showPalletUnloadDialog: false,
      showContentMismatchDialog: false,
      showInternalTransportPalletDialog: false,
      showChoosePalletDialog: false,
      palletsByNumber: [],
      chosenPallet: null,
      completed: false,
      loadingCompleteDisabled: false,
      showCompleteShipmentWarningDialog: false,
      showInternalTransportManualNumber: false,
      palletsToLoad: [],
      errorMessage: '',
      licensePlateMissing: false,
      incomplete: false,
      showTruck: false,
      showPalletsToLoad: false
    }
  },
  created: function () {
    this.startLoading()
  },
  computed: {
    showSelectLoaderType: function () {
      return this.currentType === null
    },
    showPickupAddressList: function () {
      return this.pickupAddressesLoaded && this.pickupAddresses.length > 0 && this.currentPickupAddress == null
    },
    showShipmentListReadyForPickup: function () {
      return this.currentPickupAddress !== null && this.currentType === 'SHIPMENT' && this.currentShipment === null
    },
    showShipment: function () {
      return this.currentShipment !== null
    },
    showInternalTransport: function () {
      return this.currentPickupAddress !== null && this.currentType === 'INTERN_TRANSPORT'
    },
    loadPalletButtonEnabled: function () {
      return this.palletNumberIsCorrectLength
    },
    palletNumberIsCorrectLength: function () {
      return this.currentPalletNumber !== null && ('' + this.currentPalletNumber).length >= 2 && ('' + this.currentPalletNumber).length <= 6
    },
    showShipmentComment: function () {
      return this.currentShipment && this.currentShipment.comment
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR')
    },
    hasCustomerRole: function () {
      return this.$store.getters['session/hasRole']('CUSTOMER')
    },
    hasLoaderRole: function () {
      return this.$store.getters['session/hasRole']('LOADER')
    },
    hasSupplierRole: function () {
      return this.$store.getters['session/hasRole']('SUPPLIER')
    },
    hasCarrierRole: function () {
      return this.$store.getters['session/hasRole']('CARRIER')
    },
    handleShipments: function () {
      return this.hasContractorRole || this.hasLoaderRole || this.hasSupplierRole
    },
    handleInternalTransport: function () {
      return this.hasCarrierRole || this.hasLoaderRole
    },
    emptyInternalTransport: function () {
      return this.currentShipment && this.currentShipment.internalTransport && this.pallets.length === 0
    },
    completeShipmentDisabled: function () {
      return this.loadingCompleteDisabled || this.emptyInternalTransport
    },
    canCancelInternalTransport: function () {
      return this.emptyInternalTransport
    },
    loadManualButtonEnabled: function () {
      return this.palletNumberIsCorrectLength
    },
    filteredShipments: function () {
      let shipments = this.shipments
      if (this.completed || (this.loadingReceipts && this.loadingReceipts.length > 0)) {
        shipments = []
        for (let shipment of this.shipments) {
          let found = false
          for (let lr of this.loadingReceipts) {
            if (shipment.id === lr.shipment.id) {
              found = true
              if (this.completed) {
                shipments.push(shipment)
                break
              }
            }
          }
          if (!this.completed && !found) {
            shipments.push(shipment)
          }
        }
      }
      return shipments
    },
    hasPalletsToLoad: function () {
      return this.palletsToLoad && this.palletsToLoad.length > 0
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    startLoading: function () {
      this.currentType = null
      this.pickupAddresses = []
      this.pickupAddressesLoaded = false
      this.currentPickupAddress = null
      this.currentShipment = null
      this.showInternalTransportManualNumber = null
    },
    loadPickupAddressesForShipments () {
      // console.log('Loading pickup addresses for shipments')
      this.pickupAddresses = []
      axios.get('/backend/rest/pickup_address/loader')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddressesLoaded = true
        })
        .catch(() => {
          this.pickupAddressesLoaded = true
        })
    },
    loadPickupAddressesForInternalTransport () {
      // console.log('Loading pickup addresses for internal transport')
      this.pickupAddresses = []
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddressesLoaded = true
        })
        .catch(() => {
          this.pickupAddressesLoaded = true
        })
    },
    loadAllPickupAddresses () {
      // console.log('Loading pickup addresses')
      this.pickupAddresses = []
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddresses.sort(function (p1, p2) {
            return p1.text.localeCompare(p2.text)
          })
          this.pickupAddressesLoaded = true
        })
        .catch(() => {
          this.pickupAddressesLoaded = true
        })
    },
    loadShipmentsReadyForPickup () {
      // console.log('Loading shipments ready for pickup')
      this.shipmentsLoaded = false
      this.shipments = []
      axios.get('/backend/rest/shipment/loader/address/' + this.currentPickupAddress.id)
        .then(response => {
          this.shipments = response.data
          this.shipments.sort(function (s1, s2) {
            let pickupDate1 = s1.pickupDate ? s1.pickupDate : '9999-99-99'
            let pickupDate2 = s2.pickupDate ? s2.pickupDate : '9999-99-99'
            let res = pickupDate1.localeCompare(pickupDate2)
            if (res === 0) {
              res = (s1.number + '').localeCompare((s2.number + ''))
            }
            return res
          })
          this.shipmentsLoaded = true
        })
        .catch(() => {
          this.shipmentsLoaded = true
        })
    },
    loadLoadingReceipts () {
      this.loadingReceipts = []
      axios.get('/backend/rest/loading_receipt/address/' + this.currentPickupAddress.id)
        .then(response => {
          this.loadingReceipts = response.data
        })
    },
    loadPalletsForInternalTransport () {
      // console.log('Loading pallets ready for internal transport')
      axios.get('/backend/rest/pallet/internal_transport/address/' + this.currentPickupAddress.id)
        .then(response => {
          this.pallets = response.data
          this.palletsLoaded = true
        })
        .catch(() => {
          this.palletsLoaded = true
        })
    },
    loadShipment (shipmentId) {
      // console.log('Loading shipment')
      axios.get('/backend/rest/shipment/loader/' + shipmentId)
        .then(response => {
          this.currentShipment = response.data
          this.loadPalletsForShipment()
          this.loadPalletsToLoad()
        })
    },
    reLoadShipment () {
      // console.log('Loading shipment')
      axios.get('/backend/rest/shipment/loader/' + this.currentShipment.id)
        .then(response => {
          this.currentShipment = response.data
          this.reLoadPalletsForShipment()
          this.loadPalletsToLoad()
        })
    },
    loadPalletsForShipment () {
      this.palletOrders = []
      this.pallets = []
      this.palletPositions = [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ]
      if (this.currentShipment) {
        // console.log('Loading pallet orders for shipment ' + this.currentShipment.id)
        axios.get('/backend/rest/pallet_order/shipment/' + this.currentShipment.id)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            this.palletOrders = response.data

            if (this.palletOrders && this.palletOrders.length > 0) {
              for (let palletOrder of this.palletOrders) {
                // console.log('Set pallet on position ' + (pallet.position - 1))
                this.$set(this.palletPositions, palletOrder.position - 1, palletOrder)
              }
            } else if (this.currentShipment.internalTransport) {
              this.palletOrders = []

              // Create dummy pallet orders
              for (let i = 0; i < 10; i++) {
                let palletOrder = {
                  id: -i - 1
                }
                this.palletOrders.push(palletOrder)
                this.$set(this.palletPositions, i, palletOrder)
              }
            }

            axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
              .then(response => {
                // console.log('Pallets: ' + JSON.stringify(response.data))
                this.pallets = response.data

                if (this.pallets && this.pallets.length > 0) {
                  for (let pallet of this.pallets) {
                    // console.log('Set pallet on position ' + (pallet.position - 1))
                    this.$set(this.palletPositions, pallet.position - 1, pallet)
                  }
                }
              })
          })
      }
    },
    reLoadPalletsForShipment () {
      if (this.currentShipment) {
        // console.log('Loading pallets for shipment ' + this.currentShipment.id)
        axios.get('/backend/rest/pallet_order/shipment/' + this.currentShipment.id)
          .then(response => {
            this.palletOrders = []
            this.pallets = []
            this.palletPositions = [
              {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
              {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
            ]

            this.palletOrders = response.data

            if (this.palletOrders && this.palletOrders.length > 0) {
              for (let palletOrder of this.palletOrders) {
                this.$set(this.palletPositions, palletOrder.position - 1, palletOrder)
              }
            } else if (this.currentShipment.internalTransport) {
              this.palletOrders = []

              // Create dummy pallet orders
              for (let i = 0; i < 10; i++) {
                let palletOrder = {
                  id: -i - 1
                }
                this.palletOrders.push(palletOrder)
                this.$set(this.palletPositions, i, palletOrder)
              }
            }

            axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
              .then(response => {
                this.pallets = response.data

                if (this.pallets && this.pallets.length > 0) {
                  for (let pallet of this.pallets) {
                    this.$set(this.palletPositions, pallet.position - 1, pallet)
                  }
                }
              })
          })
      }
    },
    loadPalletsToLoad () {
      if (this.currentShipment && this.currentPickupAddress) {
        axios.get('/backend/rest/pallet/to_load/shipment/' + this.currentShipment.id + '/pickup_address/' + this.currentPickupAddress.id)
          .then(response => {
            this.palletsToLoad = response.data
          })
      } else {
        this.palletsToLoad = []
      }
    },
    selectLoaderType: function (type) {
      this.currentType = type
      this.currentShipment = null
      this.currentPickupAddress = null
      this.showInternalTransportManualNumber = null
      if (this.currentType === 'SHIPMENT') {
        this.loadPickupAddressesForShipments()
      } else if (this.currentType === 'INTERN_TRANSPORT_SHIPMENT') {
        this.startInternalTransportShipment()
      } else if (this.currentType === 'INTERN_TRANSPORT') {
        if (this.hasCarrierRole) {
          this.loadPickupAddressesForInternalTransport()
        } else if (this.hasLoaderRole) {
          this.loadAllPickupAddresses()
        }
      }
    },
    selectPickupAddress: function (pickupAddress) {
      this.completed = false
      this.currentPickupAddress = pickupAddress
      this.showInternalTransportManualNumber = null
      if (this.currentType === 'SHIPMENT') {
        this.currentShipment = null
        this.loadShipmentsReadyForPickup()
        this.loadLoadingReceipts()
      } else if (this.currentType === 'INTERN_TRANSPORT') {
        this.loadPalletsForInternalTransport()
      }
    },
    selectShipment: function (shipmentSummary) {
      this.showTruck = true
      this.showPalletsToLoad = true
      this.loadShipment(shipmentSummary.id)
      this.loadingCompleteDisabled = false
    },
    startInternalTransportShipment: function () {
      let command = {
        command: 'CREATE_INTERNAL_TRANSPORT_SHIPMENT'
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          // console.log('Got response: ' + response)
          let shipmentCreated = response.data.shipment
          this.selectShipment({
            id: shipmentCreated.id
          })
        })
        .catch(error => {
          let errorMessage = 'Failed to unload pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.errorMessage = errorMessage
        })
    },
    deleteInternalTransportShipment: function () {
      let command = {
        command: 'DELETE_INTERNAL_TRANSPORT_SHIPMENT',
        shipmentId: this.currentShipment.id
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          this.gotoFrontPage()
        })
    },
    selectPalletForInternalTransport: function (pallet) {
      this.currentPallet = pallet
      this.showInternalTransportPalletDialog = true
    },
    deSelectPalletForInternalTransport: function () {
      this.currentPallet = null
      this.showInternalTransportPalletDialog = false
    },
    toggleFilterCompleted (completed) {
      this.completed = completed
    },
    stateLabel: function (state) {
      switch (state) {
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'DELIVERED': return 'Delivered'
      }
      return 'Unknown'
    },
    palletSelected: function (ctx) {
      this.currentPalletNumber = ctx.pallet.palletNumber
      this.currentPallet = ctx.pallet
      this.currentPosition = ctx.position
      this.lastPosition = ctx.position
      this.errorMessage = ''
      if (this.currentPallet && this.currentPallet.state === 'DELIVERED') {
        this.showPalletUnloadDialog = true
      } else {
        this.showPalletDialog = true
      }
      if (!this.currentPalletNumber) {
        this.currentPalletNumber = ''
      }
      this.chosenPallet = null
    },
    deSelectPallet: function () {
      // console.log('De-selecting pallet ' + this.currentPalletNumber)
    },
    numberClick: function (number) {
      let val = '' + this.currentPalletNumber
      if (val.length < 6) {
        let value = this.currentPalletNumber
        if (value === null) {
          value = ''
        }
        if ((number > 0 || value !== '0') || (number === 0 && value !== '0')) {
          value = value + '' + number
        }
        this.currentPalletNumber = value
        this.errorMessage = ''
      }
    },
    clear: function () {
      this.currentPalletNumber = ''
      this.errorMessage = ''
    },
    backspace: function () {
      let val = '' + this.currentPalletNumber
      if (val.length > 1) {
        this.currentPalletNumber = val.substring(0, val.length - 1)
      } else {
        this.clear()
      }
      this.errorMessage = ''
    },
    tryLoadPallet: function () {
      this.palletsByNumber = []
      if (this.palletNumberIsCorrectLength) {
        if ('SHIPMENT,INTERN_TRANSPORT_SHIPMENT'.includes(this.currentType)) {
          // Check that only one pallet exists
          axios.get('/backend/rest/pallet/summary/for_loading/by_number/' + this.currentPalletNumber)
            .then(response => {
              this.palletsByNumber = response.data

              if (this.palletsByNumber && this.palletsByNumber.length === 0) {
                this.errorMessage = 'Pallet number is not correct'
              } else if (this.palletsByNumber && this.palletsByNumber.length === 1) {
                this.chosenPallet = this.palletsByNumber[0]
                this.loadChosenPallet()
              } else {
                // Let the user decide which pallet to load
                this.showPalletDialog = false
                this.showChoosePalletDialog = true
              }
            })
        }
      }
    },
    loadChosenPallet: function () {
      let palletOrderContent = this.currentPallet.content
      let palletContent = this.chosenPallet.content
      if (this.currentShipment.fixedPalletPositions && palletOrderContent !== palletContent) {
        this.showPalletDialog = false
        this.showChoosePalletDialog = false
        this.$nextTick(() => {
          this.showContentMismatchDialog = true
        })
      } else {
        this.loadPallet(this.chosenPallet)
      }
    },
    cancelChoosePallet: function () {
      this.currentPallet = null
      this.showChoosePalletDialog = false
    },
    loadPallet: function (pallet) {
      let command = {
        command: 'LOAD_PALLET',
        shipmentId: this.currentShipment.id,
        addressId: this.currentPickupAddress ? this.currentPickupAddress.id : 0,
        palletId: pallet.id,
        palletNumber: pallet.palletNumber,
        position: this.lastPosition,
        licensePlate: this.currentShipment.licensePlate,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          // console.log('Got response: ' + response)
          this.reLoadShipment()
          this.showPalletDialog = false
          this.showContentMismatchDialog = false
          this.showChoosePalletDialog = false
        })
        .catch(error => {
          let errorMessage = 'Failed to load pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.errorMessage = errorMessage
        })
    },
    unloadPallet: function () {
      let command = {
        command: 'UNLOAD_PALLET',
        shipmentId: this.currentShipment.id,
        addressId: this.currentPickupAddress ? this.currentPickupAddress.id : 0,
        palletId: this.currentPallet.id,
        palletNumber: this.currentPallet.palletNumber,
        position: this.lastPosition,
        licensePlate: this.currentShipment.licensePlate,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          // console.log('Got response: ' + response)
          this.reLoadShipment()
          this.showPalletDialog = false
          this.showPalletUnloadDialog = false
          this.showChoosePalletDialog = false
        })
        .catch(error => {
          let errorMessage = 'Failed to unload pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.errorMessage = errorMessage
        })
    },
    cancelUnloadPallet: function () {
      this.showPalletUnloadDialog = false
    },
    tryCompleteShipment: function () {
      console.log('Try complete shipment')
      this.licensePlateMissing = !this.currentShipment.licensePlate || this.currentShipment.licensePlate.trim() === ''
      this.incomplete = this.hasPalletsToLoad
      if (this.licensePlateMissing || this.incomplete) {
        this.showCompleteShipmentWarningDialog = true
      } else {
        this.completeShipment()
      }
    },
    completeShipment: function () {
      this.loadingCompleteDisabled = true
      this.showCompleteShipmentWarningDialog = false
      let command = {
        command: 'COMPLETE_SHIPMENT',
        shipmentId: this.currentShipment.id,
        addressId: this.currentPickupAddress ? this.currentPickupAddress.id : 0,
        licensePlate: this.currentShipment.licensePlate,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          this.driveTruck()
        })
        .catch(error => {
          let errorMessage = 'Failed to complete shipment'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = errorMessage
          this.$refs.errorDialog.errorDialog = true
        })
    },
    cancelCompleteShipment: function () {
      this.showCompleteShipmentWarningDialog = false
    },
    driveTruck () {
      this.showPalletsToLoad = false
      this.$nextTick(() => {
        this.showTruck = false
        setTimeout(() => {
          if (this.currentPickupAddress) {
            this.selectPickupAddress(this.currentPickupAddress)
          } else {
            this.gotoFrontPage()
          }
        }, 2500)
      })
    },
    printDeliveryNote () {
      let url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.currentShipment.id + '&details=true&title=Delivery Note'
      window.open(url)
    },
    tryLoadInternalTransport: function () {
      this.palletsByNumber = []
      if (this.palletNumberIsCorrectLength) {
        if (this.currentType === 'INTERN_TRANSPORT') {
          // Check that only one pallet exists
          axios.get('/backend/rest/pallet/summary/for_loading/by_number/' + this.currentPalletNumber)
            .then(response => {
              this.palletsByNumber = response.data

              if (this.palletsByNumber && this.palletsByNumber.length === 0) {
                this.errorMessage = 'Pallet number is not correct'
              } else if (this.palletsByNumber && this.palletsByNumber.length === 1) {
                this.chosenPallet = this.palletsByNumber[0]
                this.loadChosenPalletInternalTransport()
              } else {
                // Let the user decide which pallet to load
                this.showChoosePalletDialog = true
              }
            })
        }
      }
    },
    loadChosenPalletInternalTransport: function () {
      this.loadInternalTransport(this.chosenPallet)
    },
    loadInternalTransport: function (pallet) {
      // console.log('Load pallet number: ' + this.currentPallet.number + ' for internal transport')
      let command = {
        command: 'LOAD_PALLET_INTERNAL_TRANSPORT',
        palletId: pallet.id,
        palletNumber: pallet.palletNumber,
        addressId: this.currentPickupAddress.id,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          if (response.data && response.data.pallet) {
            let palletLoaded = response.data.pallet
            this.currentPallet = null
            let history = {
              timestamp: command.timestamp,
              pallet: palletLoaded
            }
            this.historyItems.splice(0, 0, history)
            this.loadPalletsForInternalTransport()
            this.showChoosePalletDialog = false
            this.currentPalletNumber = null
          }
        })
        .catch(error => {
          let errorMessage = 'Failed to load pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(error.response.data.message)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = errorMessage
          this.$refs.errorDialog.errorDialog = true
        })
    },
    unloadInternalTransport: function () {
      // console.log('Unload pallet number: ' + this.currentPallet.number + ' for internal transport')
      let command = {
        command: 'UNLOAD_PALLET_INTERNAL_TRANSPORT',
        palletId: this.currentPallet.id,
        palletNumber: this.currentPallet.palletNumber,
        addressId: this.currentPickupAddress.id,
        timestamp: new Date()
      }
      axios.post('/backend/rest/command/loader', command)
        .then(response => {
          if (response.data && response.data.pallet) {
            let pallet = response.data.pallet
            this.currentPallet = null
            let history = {
              timestamp: command.timestamp,
              pallet: pallet
            }
            this.historyItems.splice(0, 0, history)
            this.loadPalletsForInternalTransport()
          }
        })
        .catch(error => {
          let errorMessage = 'Failed to unload pallet'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(error.response.data.message)
          this.$refs.errorDialog.errorTitle = error.response.data.title
          this.$refs.errorDialog.errorMessage = errorMessage
          this.$refs.errorDialog.errorDialog = true
        })
    },
    cancel: function () {
      this.currentPallet = null
      this.showPalletDialog = false
    },
    cancelInternalTransport: function () {
      this.showInternalTransportPalletDialog = false
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.plannedAmount + 'pcs.'
        }
      }
      return categories
    },
    pickupAddressIconStyle: function (pickupAddress) {
      let color = null
      if (pickupAddress.minutesToDeadline) {
        if (pickupAddress.minutesToDeadline < (24 * 60)) {
          color = '#FF6666'
        } else if (pickupAddress.minutesToDeadline < (48 * 60)) {
          color = '#FFBB66'
        }
      }
      if (color) {
        return 'color: ' + color + '; margin-right: 15px; font-size: 120%;'
      }
      return 'width: 0; color: transparent;'
    },
    startEnterPalletNumber: function () {
      this.showInternalTransportManualNumber = true
    }
  },
  watch: {
    showPalletDialog (val) {
      if (!val) {
        this.currentPosition = null
        this.currentPalletNumber = null
      }
    },
    showPalletUnloadDialog (val) {
      if (!val) {
        this.currentPallet = null
        this.currentPosition = null
        this.currentPalletNumber = null
      }
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .v-btn .v-btn__content {
  }
  .pickupAddressButton {
  }
  .truckContainer {
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
  }
  .truck {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .truck tr td.front {
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    height: 400px;
    background-color: white;
    border: none;
    padding: 0;
    background-image: url('/static/truck.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
  }
  .truck tr td {
    background-color: #D0D0D0;
    border: none;
    padding: 3px;
  }
  .truck tr.rightSide td {
    padding-bottom: 2px !important;
  }
  .truck tr.leftSide td {
    padding-top: 2px !important;
  }
  .palletDialog {
    box-shadow: none;
    background-color: white;
  }
  .numberPad {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
  }
  .numberPad tr {
    border: none;
  }
  .numberPad tr td {
    border: none;
    padding: 0.3vh;
    text-align: right;
    width: 20%;
  }
  .numberPad tr td.wide {
    width: 40%;
  }
  .numberBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loadPalletBtn {
    width: 100%;
    height: 41.8vh;
    text-align: center;
    vertical-align: center;
    padding-top: 15vh;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loadPalletBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .loadBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loadBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .loadInternalBtn {
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 4vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loadManualBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 5vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .loadManualBtn .v-icon {
    font-size: 10vh;
    color: rgb(221, 221, 221);
  }
  .disabled {
    background-color: #DDDDDD;
    cursor: default;
    color: #AAAAAA;
  }
  .disabled .v-icon {
    color: #AAAAAA;
  }
  .cancelBtn {
    width: 100%;
    height: 10vh;
    text-align: center;
    vertical-align: center;
    line-height: 10vh;
    font-size: 4vh;
    background-color: #003d30;
    border-radius: 10px;
    margin: 0;
    cursor: pointer;
    color: #DDDDDD;
    user-select: none;
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberBtn:hover {
    background-color: rgba(0, 62, 48, 0.87);
    transition: .2s cubic-bezier(.25,.8,.5,1);
  }
  .numberPadValue {
    border: 1px solid #004d40;
    border-radius: 10px;
    height: 10vh;
    width: 100%;
    cursor: pointer;
    font-size: 7vh;
    line-height: 10vh;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  table.choosePallet {
    width: 100%;
    border-collapse: collapse;
  }
  table.choosePallet th {
    border-bottom: 1px solid #808080;
    padding: 1px 5px 1px 5px;
  }
  table.choosePallet td {
    border-bottom: 1px solid #CCCCCC;
    padding: 5px;
    vertical-align: top;
    line-height: 20px;
  }
  table.palletsToLoad {
    min-width: 150px;
  }
  table.palletsToLoad td {
    background-color: transparent;
  }
  div.deliveryGroup {
    border: 1px solid #808080;
    border-radius: 3px;
    margin-bottom: 5px;
  }
  .truckLeave-leave-active {
    transition: all 1.5s cubic-bezier(0.5, 0, 1, 0.5);
  }
  .truckLeave-leave-to {
    transform: translateX(-150vw);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoLoading.vue